<h6>Latest Update &nbsp;&nbsp;&nbsp;&nbsp; Status: <u>{{latestUpdate.Status}}</u> &nbsp;&nbsp;&nbsp;&nbsp; Date: <u>{{latestUpdate.LastUpdateDate | string2date}}</u></h6>
<ng-table 
    [config]="config" 
    [columns]="columns"
    [data]="components"
></ng-table>
